import { SET_CURRENT_LANG } from './types';

// /* eslint-disable no-dupe-keys */
import T from 'i18n-react';
import EN from 'config/locales/en.json';
import { languages as languagesConfig } from 'config/languages';

import { getLanguage } from '../utils';

const langData = {
  en: EN,
};

const i18n = T;

const language = getLanguage(languagesConfig);

i18n.t = i18n.translate;
i18n.setTexts(langData[language]);

const initialState = {
  currentLang: language,
  i18n: i18n.texts,
  languages: languagesConfig,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_CURRENT_LANG: {
      i18n.setTexts(langData[action.payload]);
      localStorage.setItem('userLanguage', action.payload);
      return {
        ...state,
        i18n: i18n.texts,
        currentLang: action.payload,
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/langs/reducer.js